import React from 'react';
import { Typography, Box, Button, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { ShapeIcon } from 'icons/cards';
import Picture from 'shared/components/Picture';
import { useStyles } from '../styles';

const sliderStyles = makeStyles()((theme: Theme) => {
	return {
		root: {
			paddingLeft: 12,
			paddingRight: 12,
			paddingBottom: 24,
			position: 'relative',
			zIndex: 1,

			'& .MuiTypography-root': {
				color: '#FFFFFF',
			},
			'& .MuiButton-root': {
				whiteSpace: 'nowrap',
				width: '100%',
			},
			'& .MuiButton-contained': {
				background: '#FFFFFF',
				color: '#3889FA',
			},
			'& .MuiButton-outlined': {
				background: 'transparent',
				color: '#FFFFFF',
				border: '2px solid #FFFFFF',
				boxShadow: 'none',
				backgroundImage: 'none',
				'&:before, &:after': {
					display: 'none',
				},
			},
			[theme.breakpoints.up('sm')]: {
				paddingLeft: 21,
				'& .MuiButton-root': {
					width: 203,
					fontWeight: 500,
					fontSize: '1.2rem',
					lineHeight: '1.5rem',
				},
			},
			[theme.breakpoints.up('lg')]: {
				paddingLeft: 67,
				'& .MuiButton-root': {
					width: 260,
					fontWeight: 600,
					fontSize: '1.6rem',
					lineHeight: '2.4rem',
				},
			},
		},
		imageBox: {
			position: 'absolute',
			left: 0,
			top: 0,
			width: '100%',
			height: '100%',
			zIndex: -1,

			'& picture': {
				width: '100%',
				height: '100%',
				'& img': {
					width: '100%',
					height: 'auto',
					objectFit: 'contain',
				},
			},

			[theme.breakpoints.up('sm')]: {
				top: -40,
			},
			[theme.breakpoints.up('lg')]: {
				top: 0,
			},
		},
		text: {
			fontSize: '2.4rem',
			fontWeight: 600,
			lineHeight: '3.2rem',
			[theme.breakpoints.up('sm')]: {
				fontSize: '2.8rem',
			},
			[theme.breakpoints.up('lg')]: {
				fontSize: '4.8rem',
				fontWeight: 700,
				lineHeight: '6rem',
			},
		},
		subtext: {
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
			maxWidth: 585,
			[theme.breakpoints.up('lg')]: {
				fontSize: '2.9rem',
				lineHeight: '150%',
			},
		},
		actionsBox: {},
		startBtn: {
			paddingLeft: 50,
			paddingRight: 50,
		},
	};
});

const Banner3 = ({ handleJoin }: { handleJoin: any }) => {
	const { classes, cx } = useStyles();
	const { classes: bannerClasses } = sliderStyles();
	const theme = useTheme();

	return (
		<Box display="flex" flexDirection="column" justifyContent={{ xs: 'flex-end', lg: 'center' }} className={cx(classes.baseSlide, bannerClasses.root)}>
			<Box className={bannerClasses.imageBox}>
				<Picture
					alt="Celebrity banner"
					srcSet={[
						{
							media: `(min-width: ${theme.breakpoints.values.xs}px) and (max-width: ${theme.breakpoints.values.sm - 1}px)`,
							img: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/banners/CelebrityBanner-mobile.png',
						},
						{
							media: `(min-width: ${theme.breakpoints.values.sm}px) and (max-width: ${theme.breakpoints.values.lg - 1}px)`,
							img: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/banners/CelebrityBanner-tablet.png',
						},
						{
							media: `(min-width: ${theme.breakpoints.values.lg}px)`,
							img: 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/banners/CelebrityBanner.png',
							fallback: true,
						},
					]}
				/>
			</Box>
			<Box mb={{ xs: 3, sm: 1, lg: 2 }}>
				<Typography variant="h2" className={bannerClasses.text}>
					Have a fan base?
				</Typography>
			</Box>
			<Box mb={{ xs: 3, sm: 2, lg: 10 }}>
				<Typography variant="h2" className={bannerClasses.subtext}>
					Launch your NFTs and fan tokens to monetize it on WEB3 with Blocksport!
				</Typography>
			</Box>
			<Box className={bannerClasses.actionsBox}>
				<Button variant="contained" onClick={handleJoin} className={bannerClasses.startBtn} endIcon={<ShapeIcon />}>
					Join as celebrity
				</Button>
			</Box>
		</Box>
	);
};

export default Banner3;
